import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { CarouselContext, Slide } from 'pure-react-carousel';
import useElementVisibleAfterScroll from '../../../hooks/useIsElementVisibleAfterScroll.esm.js';
import styles from './CarouselItemWrapper.module.esm.js';
import styles$1 from '../../../blocks/CarouselSection/CarouselSection.module.esm.js';

var TOP_OFFSET = 220;
var CarouselItemWrapper = function (_a) {
    var index = _a.index, numberOfItems = _a.numberOfItems, carouselId = _a.carouselId, children = _a.children, theme = _a.theme, _b = _a.shouldCheckForWidth, shouldCheckForWidth = _b === void 0 ? false : _b;
    var divRef = React.useRef(null);
    var isVisible = useElementVisibleAfterScroll(divRef, TOP_OFFSET);
    var carouselNavigationId = "carouselNavId_".concat(carouselId);
    var carouselItemId = "carouselItemId_".concat(carouselId, "_").concat(index);
    var carouselContext = React.useContext(CarouselContext);
    var _c = __read(React.useState(carouselContext.state.currentSlide), 2), currentSlide = _c[0], setCurrentSlide = _c[1];
    var _d = __read(React.useState(!shouldCheckForWidth), 2), allowRenderChildren = _d[0], setAllowRenderChildren = _d[1];
    var isSelected = currentSlide === index;
    React.useEffect(function () {
        function onChange() {
            setCurrentSlide(carouselContext.state.currentSlide);
        }
        carouselContext.subscribe(onChange);
        return function () { return carouselContext.unsubscribe(onChange); };
    }, [carouselContext]);
    React.useEffect(function () {
        if (isVisible && shouldCheckForWidth)
            setAllowRenderChildren(true);
    }, [shouldCheckForWidth, isVisible]);
    return (React.createElement(Slide, { className: styles.slide, id: carouselItemId, index: index, innerClassName: classNames(styles.inner, theme && styles$1[theme]), onFocus: function () { return carouselContext.setStoreState({ currentSlide: index }); } },
        React.createElement("div", { "aria-atomic": "false", "aria-hidden": !isSelected, "aria-live": isSelected ? 'assertive' : undefined, "data-index": index, "data-testId": "carousel-item", ref: divRef, role: isSelected ? undefined : 'presentation', tabIndex: 0 },
            isSelected && (React.createElement("span", { className: styles$1.visuallyHidden },
                "Carousel item ",
                index + 1,
                " of ",
                numberOfItems)),
            allowRenderChildren && children,
            React.createElement("a", { className: styles$1.visuallyHidden, href: "#".concat(carouselNavigationId) }, "Click to go to carousel navigation"))));
};

export { CarouselItemWrapper as default };
//# sourceMappingURL=CarouselItemWrapper.esm.js.map
